export const enum ETipoFiltroContratado {
    PCM,
    PCS,
    SEM_VINCULO
}